/* eslint-disable max-depth */
import { Address, AddressKeys } from 'core-lib/types/Address';
import { Source } from 'core-lib/constants/sourceSKU';
import { getServiceableApiByCategory } from '../utils/getServiceableApiByCategory';

interface CheckServiceabilityType {
  currentAddress?: Address;
  requiredFields?: AddressKeys[];
  serviceName?: string;
}

export type CommonPayload = {
  pincode?: string | number;
  lat: string | number;
  lng: string | number;
};

export const checkServiceability = async ({
  currentAddress,
  serviceName = Source.ParkplusStore,
}: CheckServiceabilityType): Promise<{
  isServiceable: boolean;
  clusterId?: number;
}> => {
  const { pincode, latitude: lat, longitude: lng } = currentAddress;
  const payload = {
    pincode,
    lat,
    lng,
  };

  const { isServiceable, clusterId, error }: any = await getServiceableApiByCategory(
    serviceName,
    payload,
  );
  if (isServiceable) {
    return {
      isServiceable: true,
      clusterId,
    };
  }
  return {
    isServiceable: false,
  };
};
